import React, { Component } from 'react';
import { Button, Modal, Card } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import { Fetcher } from "../../../Helpers/fetcher.js";
import { Notify } from "../../../Helpers/notification.js";
import Dropdown from 'react-bootstrap/Dropdown';
import ToggleButton from 'react-toggle-button'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import Cookies from 'js-cookie';

import "./index.css";
class ListWebhooks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            blacklist: [],
            confirmDelete: false,
            selectedBlId: 0,
            webhookList : [],
            selectedWebhookId : 0,
            sizePerPage: 10,
            showJsonModal: false,
            jsonModalTitle: '',
            jsonModalContent: ''
        }
    }
    componentDidMount() {
        this.getWebhooklist();
        const savedSizePerPage = Cookies.get('webhookListsizePerPage');
        if (savedSizePerPage) {
            this.setState({ sizePerPage: Number(savedSizePerPage) });
        }
    }

    getWebhooklist = () => {
        const apiPath = this.props.app.apiPath;
        const userId = this.props.app.userId;
        Fetcher.get(apiPath + '/api/obd/webhooks/'+userId)
            .then(res => {
                this.setState({
                    webhookList: res,
                    confirmDelete: false,
                })
            })
            .catch(err => { console.log('Error in fetching Voice Files', err) });
    }

    confirmDelete = (status, blId) => {
        this.setState({
            confirmDelete: status,
            selectedWebhookId: blId
        });
    }

    deleteWebhook = () => {
        const wId = this.state.selectedWebhookId;
        const data = {

        }

        return Fetcher.post(this.props.app.apiPath + '/api/obd/webhooks/' + wId, { headers: { "Content-type": "application/json" }, method: 'DELETE', body: JSON.stringify(data) })
            .then(res => {
                Notify.notify(res.message);
                this.getWebhooklist();
            })
            .catch(err => {
                console.log('Error in Deleting Webhook', err);
            });
    }

    handleSizePerPageChange = (newSizePerPage) => {
        this.setState({ sizePerPage: newSizePerPage });
        Cookies.set('webhookListsizePerPage', newSizePerPage);
    }

    handleViewJson = (title, jsonString) => {
        try {
            const parsed = JSON.parse(jsonString);
            this.setState({
                jsonModalTitle: title,
                jsonModalContent: JSON.stringify(parsed, null, 2),
                showJsonModal: true
            });
        } catch (e) {
            this.setState({
                jsonModalTitle: title,
                jsonModalContent: jsonString,
                showJsonModal: true
            });
        }
    }

    closeJsonModal = () => {
        this.setState({
            showJsonModal: false,
            jsonModalTitle: '',
            jsonModalContent: ''
        });
    }

    render() {

        const webhookList = this.state.webhookList;
        let columns = '';
        
            columns = [
                {
                dataField: 'id',
                text: 'Webhook Id',
                sort: true,
                hidden : false
            },
            {
                dataField: 'webhookName',
                text: 'Webhook Name',
                sort: false,
                searchable: true
            },
            {
                dataField: 'url',
                text: 'Webhook Url',
                sort: true,
                searchable: true
            }, {
                dataField: 'event',
                text: 'Webhook Event',
                sort: false,
                searchable: true
            }, {
                dataField: 'headers',
                text: 'Headers',
                sort: false,
                searchable: false,
                formatter: (cellContent, row) => {
                    if (!row.rawHeaders) return null;
                    try {
                        const parsed = JSON.parse(row.rawHeaders);
                        if (Object.keys(parsed).length > 0) {
                            return <Button size="sm" onClick={() => this.handleViewJson('Headers', row.rawHeaders)}>View</Button>;
                        }
                    } catch (e) {
                        return null;
                    }
                    return null;
                }
            }, {
                dataField: 'body',
                text: 'Body',
                sort: false,
                searchable: false,
                formatter: (cellContent, row) => {
                    if (!row.rawBody) return null;
                    try {
                        const parsed = JSON.parse(row.rawBody);
                        if (Object.keys(parsed).length > 0) {
                            return <Button size="sm" onClick={() => this.handleViewJson('Body', row.rawBody)}>View</Button>;
                        }
                    } catch (e) {
                        return null;
                    }
                    return null;
                }
            }, {
                dataField: 'action',
                text: 'Action',
                sort: false,
                searchable: false
            },];

        const webhooks = Array.isArray(webhookList) ? webhookList.map((blist, index) => {
            
            let action = [];
                action.push(<Dropdown>
                    <Dropdown.Toggle className='btn-sm'>Take Action</Dropdown.Toggle>
                        <Dropdown.Menu>
                        <Dropdown.Item key={`${index}-edit-webhooks`} href={`${this.props.app.urlPrefix}/update-webhooks/${blist.id}`}>Edit Webhooks</Dropdown.Item>	
                          <Dropdown.Item key={`${index}-delete-webhooks`} onClick={(e) => { this.confirmDelete(true, blist.id) }} href="#">Delete Webhooks</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>);
            return {
                id : blist.id,
                webhookName: blist.webhookName,
                url: blist.url,
                event: blist.event,
                rawHeaders: blist.headerJson || '',
                rawBody: blist.bodyJson || '',
                action: action
            };
        }) : []
        const { SearchBar, ClearSearchButton } = Search;

        const defaultSorted = [{
            dataField: 'id',
            order: 'desc'
        }];

        const paginationOption = {
            custom: true,
            totalSize: webhooks.length,
            sizePerPage: this.state.sizePerPage,
            sizePerPageList: [10, 25, 50, 100],
            onSizePerPageChange: this.handleSizePerPageChange
        };

        return (
            <Card>
                <Card.Header>Webhook List</Card.Header>
                <Card.Body>
                    <div className="campaign-list-table-cont">
                        {<PaginationProvider pagination={paginationFactory(paginationOption)}>
                            {
                                ({
                                    paginationProps,
                                    paginationTableProps
                                }) => (<ToolkitProvider keyField="webhookId" data={webhooks} columns={columns} search bootstrap4>
                                    {props => (<div className="">
                                        Show <SizePerPageDropdownStandalone className="search-dropdown" {...paginationProps} /> items
                                        <span className="search-cont"><SearchBar {...props.searchProps} /></span>
                                        <ClearSearchButton className="btn-primary" {...props.searchProps} />
                                        <hr />
                                        <BootstrapTable bordered={true} hover condensed defaultSorted={defaultSorted} wrapperClasses="table-responsive" classes="blacklist-table" {...props.baseProps} {...paginationTableProps} noDataIndication={() => (<div>{'No data available'}</div>)} />
                                        <PaginationListStandalone {...paginationProps} />
                                    </div>)}
                                </ToolkitProvider>)
                            }
                        </PaginationProvider>}
                    </div>
                    <Modal size="md" show={this.state.confirmDelete} onHide={() => this.confirmDelete(false, '')}>
                        <Modal.Header closeButton>
                            <Modal.Title id="example-modal-sizes-title-sm">
                                Delete Webhook
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            Are you sure you want to delete this Webhook?
                        </Modal.Body>
                        <Modal.Footer>
                            <Button onClick={() => this.confirmDelete(false, '')} variant="secondary">CANCEL</Button>
                            <Button onClick={this.deleteWebhook} variant="primary">YES</Button>
                        </Modal.Footer>
                    </Modal>

                    {/* Json modal */}
                    <Modal size="md" show={this.state.showJsonModal} onHide={this.closeJsonModal}>
                        <Modal.Header closeButton>
                            <Modal.Title>{this.state.jsonModalTitle}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <pre style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '5px', maxHeight: '400px', overflow: 'auto' }}>
                                {this.state.jsonModalContent}
                            </pre>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.closeJsonModal}>Close</Button>
                        </Modal.Footer>
                    </Modal>
                </Card.Body>
            </Card>
        );
    }
}


export default ListWebhooks;